<div class="content-container">
  <mat-form-field appearance="outline" class="form-field" *ngIf="show">
    <mat-label>Depth with steps</mat-label>
    <input matInput type="number" AutoComplete="off" [ngModel]="entranceDoor?.stepDepth"
      (ngModelChange)="entranceDoor.stepDepth = $event" (keypress)="integerOnly($event)">
  </mat-form-field>
  <mat-form-field class="form-field">
    <mat-label>Number of steps</mat-label>
    <mat-select class="text-right" [value]="entranceDoor?.stepAmount" (selectionChange)="changeSteps($event.value)">
      <mat-option class="select-without-checkbox" *ngFor="let step of stepAmounts" [value]="step.ID">
        {{step.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="form-field" *ngIf="show">
    <mat-label>Door wing type</mat-label>
    <mat-select [value]="door.doorWingType" (selectionChange)="changeDoorWingType($event.value)">
      <mat-option class="select-without-checkbox" *ngFor="let doorWingType of doorWingTypes" [value]="doorWingType.ID">
        {{doorWingType.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="entranceDoor?.gapBridge"
    (ngModelChange)="entranceDoor.gapBridge = $event" class="form-field">
    Gap bridging
  </mat-checkbox>
  <mat-form-field class="form-field">
    <mat-label>Separating element</mat-label>
    <mat-select [value]="entranceDoor.physicalSplitElement" (selectionChange)="changeSplitElement($event.value)">
      <mat-option class="select-without-checkbox" *ngFor="let splitElement of physicalSplitElementSource"
        [value]="splitElement.ID">
        {{splitElement.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field *ngIf="showFeatureBycicleAmountSingle" appearance="outline" class="form-field">
    <mat-label>Number of bycicles</mat-label>
    <input matInput type="number" [ngModel]="multiPurposeAreaComponent?.bycicleAmount"
      (ngModelChange)="multiPurposeAreaComponent.bycicleAmount = $event" autocomplete="off"
      (keypress)="integerOnly($event)">
  </mat-form-field>
  <mat-form-field *ngIf="showFeatureSkiAmountSingle" appearance="outline" class="form-field">
    <mat-label>Number of skis</mat-label>
    <input matInput type="number" [ngModel]="multiPurposeAreaComponent?.skiAmount"
      (ngModelChange)="multiPurposeAreaComponent.skiAmount = $event" autocomplete="off"
      (keypress)="integerOnly($event)">
  </mat-form-field>
  <mat-form-field *ngIf="showFeatureStrollerAmountSingle" appearance="outline" class="form-field">
    <mat-label>Number of strollers</mat-label>
    <input matInput type="number" [ngModel]="multiPurposeAreaComponent?.strollerAmount"
      (ngModelChange)="multiPurposeAreaComponent.strollerAmount = $event" autocomplete="off"
      (keypress)="integerOnly($event)">
  </mat-form-field>
  <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="personsPerSquareMeterComponent?.overrideDefaultValue"
    (ngModelChange)="personsPerSquareMeterComponent.overrideDefaultValue = $event" class="form-field">
    Override default value
  </mat-checkbox>
  <mat-form-field appearance="outline" class="form-field" *ngIf="personsPerSquareMeterComponent.overrideDefaultValue">
    <mat-label>Number of people per m<sup>2</sup></mat-label>
    <input matInput type="number" step="0.5" [ngModel]="personsPerSquareMeterComponent?.amountOfPeople"
      (ngModelChange)="personsPerSquareMeterComponent.amountOfPeople = $event" autocomplete="off">
  </mat-form-field>
</div>